import { color } from "lib/theme/color";
import { size } from "lib/theme/size";
import theme from "lib/theme/theme";
import { SxObjType } from "lib/theme/types/SxObjType.type";

const iconSize = size.FONTSIZE_24;
const sxStyles = (titleBold: boolean) => {
  return {
    card: {
      display: "flex",
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
      justifyContent: "space-between",
      boxShadow: "0px 0px 6px " + color.RGBA_52,
      "&:not(:last-child)": {
        marginBottom: theme.spacing(2),
      },
      borderRadius: theme.spacing(1),
    },

    actionArea: {
      padding: theme.spacing(1.75),
      "&:hover $focusHighlight": { opacity: 0 },
    },

    textContainer: {
      // marginLeft: theme.spacing(1.25),
      // paddingRight: theme.spacing(1.5),
      alignItems: "center",
    },

    title: {
      lineHeight: 1,
      color: theme.palette.grey[400],
      typography: titleBold
        ? theme.typography.body1_semibold
        : theme.typography.body1_regular,
    },
    body: {
      color: theme.palette.grey[400],
      typography: theme.typography.body1_regular,
    },

    content: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      padding: 0,
      "&:last-child": {
        paddingBottom: theme.spacing(2),
      },
    },
    checkbox: { p: 1 },
    checkboxText: {
      alignItems: "center",
    },
    checkIcon: {
      width: iconSize,
    },
  } satisfies SxObjType;
};

export { sxStyles };
